import React, { useState } from 'react';
import TagsInput from 'react-tagsinput';

const CustomTagInput = ({onTagsChanged, tags}) => {

    return <TagsInput value={tags} onChange={onTagsChanged} className="tags-input" />
}

export default CustomTagInput